import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { shadowStyles } from '@styles/global/shadows'

interface IProps {
  videoId: string
  altTag?: string
}

function WistiaVideo ({ videoId, altTag = 'Every Tuesday Course Trailer' }: IProps) {
  const [loaded, setLoaded] = useState(false)
  useEffect(() => {
    const script1 = document.createElement('script')
    const script2 = document.createElement('script')

    script1.src = `https://fast.wistia.com/embed/medias/${videoId}.jsonp`
    script1.async = true

    script2.src = 'https://fast.wistia.com/assets/external/E-v1.js'
    script2.async = true

    document.body.appendChild(script1)
    document.body.appendChild(script2)
  }, [])

  return (
    <VideoWrapper>
      <VideoShadow className='embed-responsive embed-responsive-16by9 et-box-shadow'>
        <div className='wistia_responsive_padding'
             style={{ padding: '56.25% 0 0 0', position: 'relative' }}>
          <div
            className='wistia_responsive_wrapper'
            style={{ height: '100%', left: 0, position: 'absolute', top: 0, width: '100%' }}>
            <div className={`wistia_embed wistia_async_${videoId} videoFoam=true`}
                 style={{ height: '100%', position: 'relative', width: '100%' }}
            >
              <div className='wistia_swatch'
                   style={{
                     opacity: loaded ? 1 : 0,
                     height: '100%',
                     left: 0,
                     overflow: 'hidden',
                     position: 'absolute',
                     top: 0,
                     transition: 'opacity 200ms',
                     width: '100%',
                   }}
              >
                <img src={`https://fast.wistia.com/embed/medias/${videoId}/swatch`}
                     style={{ filter: 'blur(5px)', height: '100%', objectFit: 'contain', width: '100%' }}
                     alt={altTag}
                     onLoad={() => {setLoaded(true)}}/>
              </div>
            </div>
          </div>
        </div>
      </VideoShadow>
    </VideoWrapper>
  )
}

export default WistiaVideo

const VideoWrapper = styled.div`
  position: relative;
  z-index: 5;
`
const VideoShadow = styled.div`
  box-shadow: ${shadowStyles.shadow1};
`
